import React from 'react';
import PropTypes from 'prop-types';

import { TableRow, TableCell, Button } from '@mui/material';
import { Link } from 'react-router-dom';

import { green, red } from '@mui/material/colors';

import Avatar from '@mui/material/Avatar';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const ListItem = props => {
  const { order } = props;
  const {
    id,
    status,
    createDate,
    modifyDate,
    basket,
    externalProviderName,
    externalOrderId
  } = order;

  return (
    <TableRow>
      <TableCell>
        {status === 'READY' ? (
          <Avatar className={{
            margin: 10,
            color: '#fff',
            backgroundColor: green[500]
          }}>
            <AssignmentTurnedInIcon />
          </Avatar>
        ) : (
          <Avatar style={{
            margin: 10,
            color: '#fff',
            backgroundColor: red[500]
          }}>
            <AssignmentLateIcon />
          </Avatar>
        )}
      </TableCell>
      <TableCell>
        <Button component={Link} to={`/order/${id}`}>
          {id.substr(1, 7)}
        </Button>
      </TableCell>
      <TableCell>
        {new Date(createDate)
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ')}
      </TableCell>
      <TableCell>
        {new Date(modifyDate)
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ')}
      </TableCell>
      <TableCell>
        {basket && basket.items && (
          <ul>
            {basket.items.map(item => (
              <li>{item.name}</li>
            ))}
          </ul>
        )}
        {typeof basket === 'string' && { basket }}
      </TableCell>
      <TableCell>{`${externalProviderName}, ${externalOrderId}`}</TableCell>
    </TableRow>
  );
};

ListItem.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    createDate: PropTypes.number.isRequired,
    modifyDate: PropTypes.number.isRequired,
    basket: PropTypes.string.isRequired,
    externalProviderName: PropTypes.string.isRequired,
    externalOrderId: PropTypes.string.isRequired
  }).isRequired
};

ListItem.defaultProps = {};

export default ListItem;
